import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../styles/Community.scss';
import icon from '../assets/newWrite.svg';

const CommunityWritePage = () => {
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;
  const { user } = useAuth();
  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');
  const [category, setCategory] = useState<string>('기타'); // 기본값
  const [hashtagInput, setHashtagInput] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    if (isEditMode) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`/api/community/${id}`);
          const post = response.data;
          setTitle(post.title);
          setContent(post.content);
          setCategory(post.category);
          setHashtagInput(post.hashtags.join(' '));
        } catch (error) {
          console.error('Error fetching post for editing:', error);
        }
      };
      fetchPost();
    }
  }, [id, isEditMode]);

  const categories = [
    '모든 사연',
    '연애',
    'LGBT',
    '외모',
    '대인관계/따돌림',
    '정신건강',
    '성생활',
    '취업/진로',
    '학업/고시',
    '이별/이혼',
    '부부관계',
    '펫로스',
    '성범죄',
    '신체건강',
    '육아/출산',
    '직장',
    '금전/사업',
    '자아/성격',
    '가족',
    '기타',
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!user) {
      alert('로그인이 필요합니다.');
      return;
    }

    const hashtags = [
      ...new Set(
        hashtagInput
          .split(/\s+/)
          .filter(Boolean)
          .map(tag => (tag.startsWith('#') ? tag : `#${tag}`))
      ),
    ];

    try {
      if (isEditMode) {
        await axios.put(`/api/community/${id}`, {
          title,
          content,
          category,
          hashtags,
        });
        navigate(`/community/${id}`);
      } else {
        await axios.post('/api/community/add', {
          title,
          content,
          userId: user.id,
          category,
          hashtags,
        });
        navigate('/community');
      }
    } catch (error) {
      console.error('Error saving post:', error);
    }
  };

  return (
    <div className="app-container community-write-container">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">{isEditMode ? '글 수정' : '새 글 작성'}</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>카테고리</label>
          <select value={category} onChange={e => setCategory(e.target.value)}>
            {categories.map(cat => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>제목</label>
          <input type="text" value={title} onChange={e => setTitle(e.target.value)} />
        </div>
        <div className="form-group">
          <label>내용</label>
          <ReactQuill theme="snow" value={content} onChange={setContent} />
        </div>
        <div className="form-group">
          <label>해시태그</label>
          <input
            type="text"
            value={hashtagInput}
            onChange={e => setHashtagInput(e.target.value)}
            placeholder="#태그1 #태그2 형태로 입력하세요"
          />
        </div>

        <div className="form-actions">
          {isEditMode ? (
            <button
              type="button"
              className="back-btn"
              onClick={() => {
                navigate(`/community/${id}`);
              }}
            >
              취소
            </button>
          ) : (
            <button
              type="button"
              className="back-btn"
              onClick={() => {
                navigate(`/community`);
              }}
            >
              취소
            </button>
          )}
          <button type="submit" className="submit-btn">
            {isEditMode ? '수정 완료' : '작성 완료'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommunityWritePage;
